import { productPrimaryImageStyles } from "@insite/content-library/Components/ProductPrimaryImage";
import Img, { ImgProps } from "@insite/mobius/Img";
import { css } from "styled-components";

productPrimaryImageStyles.centeringWrapper={
    css: css`
    min-height: 300px;
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
        max-height:300px;
        max-width: 100%;
    }
`
        
}